<template>
  <div>
    <span>
      <button
        v-on:click="musteriDetay()"
        style="border: none; background: none; margin-right: 5px"
      >
        <Icon icon="akar-icons:search" color="#7367f0" width="30" height="30" />
      </button>
    </span>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { Icon } from "@iconify/vue2";

import router from "../../../../router";

import { BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
  components: {
    Icon,
    BDropdown,
    BDropdownItem,
  },
  methods: {
    musteriDetay() {
      router.push({
        name: "MusterilerDetay",
        params: { item: this.params.data },
      });
    },
  },
};
</script>